import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Frontend = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);
  return (
    <div>
 <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">What will I learn in this course?</h1>
          <ul>
            <li>HTML5</li>
            <li>CSS3</li>
            <li>JavaScript</li>
            <li>Bootstrap</li>
          </ul>
          <p><b>Session 1: HTML</b></p>
          <p>HTML5,HTML tags and Attributes, Links, Images, Lists, Tables, HTML Forms,Frames and Nested Frames</p>
          <p><b>Session 2: CSS</b></p>
          <p>CSS3,CSS selectors,Pseudo Classes,Style Properties</p>
          <p><b>Session 3: JavaScript</b></p>
          <p>Programming constructs,Functions and Objects,Standard Objects,Event Handling</p>
          <p><b>Session 4: Bootstrap</b></p>
          <p>Bootstrap Typography,Bootstrap Grid,Bootstrap UI components,Photoshop</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Frontend